import { useEffect, useState } from 'react';

export function useIsMobile(breakpoint = 850) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

  useEffect(() => {
    function handleResize() {
      const isMobileNow = window.innerWidth <= breakpoint;

      if (isMobileNow !== isMobile) {
        setIsMobile(isMobileNow);
      }
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint, isMobile]);

  return isMobile;
}
